import { ContentSection } from '@fb-tool-front/shared/interfaces/shared.type';
import { ProductCatalog, ProductSet } from '@fb-tool-front/shared/interfaces/catalogs.type';

export const CONTENT_SECTIONS: ContentSection[] = [
  {
    id: 'properties',
    name: 'Product set properties'
  },
  {
    id: 'download-csv',
    name: 'Download CSV template'
  },
  {
    id: 'upload-csv',
    name: 'Upload instruction CSV'
  }
];

export const RADIO_BUTTON_OPTIONS: any[] = [
  {
    label: 'Static',
    value: 'static',
    description: 'Can’t be edited or updated'
  },
  {
    label: 'Dynamic',
    value: 'dynamic',
    description: 'Automatically keeps your data up to date'
  }
];

export const PRODUCT_SET_TIMINGS = [
  {
    value: '0 */1 * * *',
    name: 'Every 1 hour'
  },
  {
    value: '0 */4 * * *',
    name: 'Every 4 hours'
  },
  {
    value: '0 */24 * * *',
    name: 'Every 24 hours'
  },
  {
    value: '0 0 * * 0',
    name: 'Once a week'
  }
];

export const CSV_URL_REGEX = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6}).+$/;

export const SIMPLE_OVERLAY_PROVIDER = 'default';

export const ALL_PRODUCTS = ['all products', 'все продукты', 'все'];

export const DEMO_PRODUCT_SET_EN = {
  id: 'demo_en',
  name: 'All products',
  product_count: 77
} as ProductSet;

export const DEMO_PRODUCT_SET_RU = {
  id: 'demo_ru',
  name: 'Все продукты',
  product_count: 92
} as ProductSet;

export const DEMO_CATALOG_EN = {
  id: 'demo_en',
  name: 'Demo catalog',
  vertical: 'commerce',
  product_count: 77,
  overlays: [],
  feeds: [],
  tasks: ['DEMO'],
  product_sets: [DEMO_PRODUCT_SET_EN]
} as ProductCatalog;

export const DEMO_CATALOG_RU = {
  id: 'demo_ru',
  name: 'Демо каталог',
  vertical: 'commerce',
  product_count: 92,
  overlays: [],
  feeds: [],
  tasks: ['DEMO'],
  product_sets: [DEMO_PRODUCT_SET_RU]
} as ProductCatalog;

export const enum ToggleMultiCountryOverlayMode {
  apply = 'apply',
  remove = 'remove'
}
